export default __webpack_public_path__ + "static/media/coffee.c00edaca.svg";